import React, { useState } from "react";
import { Button } from "reactstrap";
import ActionButtonRounded from "../../../../components/Buttons/ActionButtonRounded";

export default function CommandButtons({
  searchControl,
  setSearchControl,
  lastSearchStringUpdate,
  getData,
  modalAddGroupsControl,
  setModalAddGroupsControl,
}) {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        marginBottom: 10,
      }}
    >
      <form
        className="app-search d-none d-lg-block events-input-search"
        onSubmit={(e) => e.preventDefault()}
      >
        <div className="position-relative">
          <input
            value={searchControl.search}
            type="text"
            className="form-control"
            placeholder="Pesquisar..."
            onChange={(e) => {
              setSearchControl({ ...searchControl, search: e.target.value });
              lastSearchStringUpdate.current = Date.now();
              setTimeout(() => {
                if (lastSearchStringUpdate.current + 500 < Date.now()) {
                  getData();
                }
              }, 600);
            }}
          />
          <span className="bx bx-search-alt" />
        </div>
      </form>
      <div className="header-btns-container">
        <ActionButtonRounded
          title="Criar Stands"
          onClick={() =>
            setModalAddGroupsControl({ ...modalAddGroupsControl, open: true })
          }
        />
      </div>
    </div>
  );
}
